import {ref} from 'vue';
import {Ref} from '@vue/reactivity';

class BrowserlocationComposition {
    private _isUsingBrowserLocation: Ref<boolean> = ref(false);
    private _isBrowserLocationPending: Ref<boolean> = ref(false);
    private _hasBrowserLocationPermission: Ref<boolean> = ref(true);

    get isUsingBrowserLocation(): boolean {
        return this._isUsingBrowserLocation.value;
    }

    set isUsingBrowserLocation(value: boolean) {
        this._isUsingBrowserLocation.value = value;
    }

    get isBrowserLocationPending(): boolean {
        return this._isBrowserLocationPending.value;
    }

    set isBrowserLocationPending(value: boolean) {
        this._isBrowserLocationPending.value = value;
    }

    get hasBrowserLocationPermission(): boolean {
        return this._hasBrowserLocationPermission.value;
    }

    set hasBrowserLocationPermission(value: boolean) {
        this._hasBrowserLocationPermission.value = value;
    }
}

export const useBrowserlocationComposition = new BrowserlocationComposition();
